

document.addEventListener('DOMContentLoaded', function () {
  var appliedDiscountCookie = 'first_order_discount_applied';
  var discountCode = 'first_time_discount';
  //check url if cart page
  let is_cart = false;
  let url = window.location.href;
  if (url.includes('/cart')) {
    is_cart = true;
  }
  if (is_cart) {

    if (Cookies && !Cookies.get(appliedDiscountCookie)) {
      var cartDiscountApplied = false;

      // Check if the discount code is applicable to the cart
      Shopify.Cart.discount(discountCode).then(function (discount) {
        if (discount.status === 'success') {
          // Apply the discount
          cartDiscountApplied = true;
          Cookies.set(appliedDiscountCookie, 'true', { expires: 365 }); // Set a cookie to prevent multiple uses

          // Update the cart with the applied discount
          Shopify.Cart.getCart().then(function (cart) {
            var updates = {};
            updates[cart.items[0].key] = { quantity: cart.items[0].quantity, discounts: [discountCode] };

            Shopify.Cart.updateCart(updates).then(function () {
              console.log('First order discount applied.');
            });
          });
        }
      });

      // If the discount was not applied, display an error message
      setTimeout(function () {
        if (!cartDiscountApplied) {
          console.log('First order discount could not be applied.');
        }
      }, 5000);
    }
  }
});